export default __webpack_public_path__ + "static/media/good-icon.84efae6e.svg";